import { AlphamapLogo } from 'src/layout/alphamap-logo'
import styled from '@emotion/styled'

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(13, 22, 33, 1);
`

export const FullScreenLoader = () => {
  return (
    <Wrapper>
      <AlphamapLogo />
    </Wrapper>
  )
}
